// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3VMWB","title":"ClientReferral_title__20aFo","itemText":"ClientReferral_itemText__YKwLW"};